<template>
	<div class="ReSearchScndObjMap">
		<yandex-map
			:settings="yamap_settings"
			:coords="yamap_coords"
			:zoom="yamap_zoom"
			:controls="yamap_controls"
			:scroll-zoom="true"
			:cluster-options="clusterOptions"
			:use-html-in-layout="true"
			>
				<ymap-marker v-for="marker in yamap_markers" :key="marker.id"
					:coords="marker.coords"
					:marker-id="marker.id"
					:icon="{color: marker.markerColor, content: marker.houseClassMarker}"
					:balloon-template="marker.balloonTemplate"
					:balloon="marker.clusterBalloonTemplate"
					cluster-name="cluster"
				/>
		</yandex-map>
	</div>
</template>

<script>
	import { yandexMap, ymapMarker } from 'vue-yandex-maps';
	import mapSettings from 'src/conf/yandexmap.js';
	export default {
		name: 'ReSearchScndObjMap',
		components: { 
			yandexMap, 
			ymapMarker
		},
		props: {
			objData: [Object,Array]
		},
		data () {
			return {
				ver: 1,
				yamap_settings: { ...mapSettings	},
				yamap_coords: [59.93984485554249, 30.314527237792984],
				yamap_zoom: 11,
				yamap_controls:['zoomControl','typeSelector'],
				yamap_markers:[],
				clusterOptions: {
					clusterDisableClickZoom: true,
					clusterOpenBalloonOnClick: true,
				},
			}
		},
		watch: {
			objData(){
				this.makeMarkers();
			}
		},
		methods: {
			makeMarkers(){
				this.yamap_markers = [];
				const objGetParams = this.$GVO.GetAllGet();

				for (let i = 0; i < this.objData.length; i++) {
					const objSecond = this.objData[i];

					const houseClassMarker = 'Не классифицировано';
					
					const markerColor = 'grey';
					if(objSecond.result_id == '1'){
						markerColor = 'grey';
						houseClassMarker = 'Не классифицировано';
					}else if(objSecond.result_id == '2') {
						markerColor = 'lightBlue';
						houseClassMarker = 'В работу (в работе)';
					}else if(objSecond.result_id == '3') {
						markerColor = 'orange';
						houseClassMarker = 'Перезвонить (нельзя классифицировать)';
					}else if(objSecond.result_id == '4') {
						markerColor = 'green';
						houseClassMarker = 'Агент (делится комиссией)';
					}else if(objSecond.result_id == '5') {
						markerColor = 'blue';
						houseClassMarker = 'Агент (не делится комиссией)';
					}else if(objSecond.result_id == '6') {
						markerColor = 'yellow';
						houseClassMarker = 'Отказ от сотрудничества';
					}else if(objSecond.result_id == '7') {
						markerColor = 'black';
						houseClassMarker = 'Объекта не существует';
					}else if(objSecond.result_id == '8') {
						markerColor = 'red';
						houseClassMarker = 'Объект продан';
					}
					
					let strConstGetParams = '';
					if(typeof objGetParams.task_id != 'undefined' && typeof objGetParams.taskend_id != 'undefined' && typeof objGetParams.client_id != 'undefined'){
						strConstGetParams = `?task_id=${objGetParams.task_id}&taskend_id=${objGetParams.taskend_id}&client_id=${objGetParams.client_id}`;
					}
					// let strComplexUrl = '/data/module/sso/object/complex/'+objComplex.gk_name_tr+strConstGetParams;
					let strObjUrl = '/data/module/sso/object/second/'+objSecond.id+strConstGetParams;
					let strImg = '/img/icons/map/map_icon_ready.svg';
					let metroBaloon = '';
					if(objSecond.metroName){
						metroBaloon = `<div class="metroPathTime mr-2">
											<i class="tim-ic ic-metro mr-2 text-primary"></i>
											<p class="">${objSecond.metroName}</p>
										</div>`
					}else metroBaloon = '';
					
					let cellId = '';
					let cellName = '';
					if(objSecond.cellInfo.length>0){
						if(objSecond.cellInfo[0].cellId != '' && objSecond.cellInfo[0].cellId != null ){
							cellId = objSecond.cellInfo[0].cellId;
						}else cellId = '';
						if(objSecond.cellInfo[0].cellName != '' && objSecond.cellInfo[0].cellName != null ){
							cellName = objSecond.cellInfo[0].cellName;
						}else cellName = '';
						// console.log(objSecond.cellInfo[0].cellName);
					}
					let salesType = '';
					if(objSecond.salesType != '' && objSecond.salesType != null ){
						salesType = `<span class="badge badge-primary mr-2">${objSecond.salesType}</span>`;
					}
					let result_name = '';
					let result_descr = '';
					if(objSecond.result_name != '' && objSecond.result_name != null ){
						result_name = `<div class="complexName"><p>Классификация звонка: ${objSecond.result_name}</p></div>`;
					} else result_name ='';
					if(objSecond.result_descr != '' &&  objSecond.result_descr != null ){
						result_descr = `<div class="complexName"><p>Примечание звонка: ${objSecond.result_descr}</p></div>	`;
					} else result_descr ='';					
									
					let clusterAddress = '';
					if(objSecond.address && objSecond.address !=''){
						clusterAddress = objSecond.address;
					} else if (objSecond.houseAddress && objSecond.houseAddress !=''){
						clusterAddress = objSecond.houseAddress;
					} else {clusterAddress = objSecond.district}

					this.yamap_markers.push({
						id: i,
						coords: [objSecond.latitude, objSecond.longitude],
						markerIcon: {
							layout: 'default#imageWithContent',
							// imageHref: strImg,
							imageSize: [33, 40],
							imageOffset: [-18, -35],
						},						
						markerColor: markerColor,
						houseClassMarker: houseClassMarker,
						clusterBalloonTemplate: {
							header: `Адрес: ${clusterAddress}`,
							// body:
							// `ID: ${objSecond.id} \r\n
							// Класс: ${objSecond.cat_living_class_name} \r\n
							// Год постройки: ${objSecond.year} \r\n
							// Серия (тип дома): ${objSecond.series_building} \r\n							
							// `,
							body: [
								['ID: ' + objSecond.id, 
								'Класс: ' + objSecond.houseCatLivingClassName,  // было objSecond.cat_living_class_name
								'Год постройки: ' + objSecond.houseStartYear, // было objSecond.year
								'Серия (тип дома): ' + objSecond.houseSeriesBuilding, // было objSecond.series_building
								'<a href="'+ strObjUrl + strConstGetParams +'">Посмотреть объект № ' +objSecond.id+ '</a>'
								].join('<br/>'),
							],
						},
						balloonTemplate: `
							<div class="cardComplex" style="height: auto !important;">
								
								<div class="img">
									<a href="${strObjUrl}">
										<img alt="${objSecond.title}" onerror="this.src='/img/flatsDefault.svg'; this.onerror=''" title="${objSecond.title}" src="${objSecond.mainPhoto}">
									</a>
								</div>
								<div class="row align-items-center mx-0 mt-3">
									<span class="badge badge-primary mr-2">${objSecond.source}</span>
									${salesType}
								</div>				
								<div class="objInfo">
									<div class="complexName"><a href="${strObjUrl}">${objSecond.title}</a></div>
									<div class="complexName"><p>S общая ${this.$GVO.number_format(objSecond.area,0,'.',' ')} м²</p></div>
									
									<div class="price"><p>Цена: ${this.$GVO.number_format(objSecond.price,0,'.',' ')} ₽</p></div>

									<div class="address d-flex">							
										${metroBaloon}
										<div class="objectLocation">
											<div class="objectAddress"><p>${objSecond.region}, ${objSecond.address}</p></div>
										</div>
									</div>
									<div class="complexName"><p>Ячейка ID${cellId} "${cellName}"</p></div>
									${result_name}
									${result_descr}
															
								</div>
							</div>
						`
					});
				}
			}
		},
		mounted() {
			this.makeMarkers();
		}
	}
</script>
<style>
	.ymap-container{height: 600px; width: 100%;}
	.ReSearchScndObjMap{position: relative; width: 100%;}
	.cardComplex .img{
		width: 100%;
		margin: 0 auto;
    	display: flex;
		margin-bottom: 15px;
		padding-top: 15px;
	}
	.cardComplex .img img{max-width: 300px; object-fit: cover; height: 180px;}
	.cardComplex .img a{display: inline-block; margin: 0 auto;}
	.cardComplex p {color: #000;}
	.complexName {margin-bottom: 5px;}
	.metroPathTime, .districtStreet {display: flex; align-items: center;}
	.objInfo {padding: 0px 10px;}
	.flatCount {margin-bottom: 5px;}
	.ymaps-2-1-77-balloon__content{
		margin-right: 0px!important;
		padding: 20px!important;
	}
	/*===media===============================*/
	@media (max-width: 768px) {	
		.ymap-container {height: 450px;}
	}
</style>
